import React, {useEffect, useState} from 'react';
import Frame from "../components/layout/Frame";
import Container from "react-bootstrap/Container";
import {Col, Row} from "react-bootstrap";
import StatisticsDateSearchBox from "../components/searchBoxs/StatisticsDateSearchBox";
import {getPerfBKList} from "../api/apiClient";
import Moment from "moment";
import TableBKS from "../components/tables/TableBKS";

const PerfBrokerServer = () => {

  /* pagination을 위한 state */
  const [listPageSize, setListPageSize] = useState(15);
  const [tableList, setTableList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);

  const now = new Date();	// 현재 날짜 및 시간
  const oneMonthAgo = new Date(now.setMonth(now.getMonth() - 1));	// 한달 전
  // 검색 조건
  const [searchParam, setSearchParam] = useState({
    startDate: oneMonthAgo,
    searchFromSi: '',
    searchTerm: 'H',    // 통계주기
    endDate: new Date(),
    searchToSi: '',
  });
  // 검색 버튼 클릭했는지
  const [isSearch, setIsSearch] = useState(true);

  // 리스트 갱신
  const updateList = () => {
    getPerfBKList(currentPage, listPageSize,
        Moment(searchParam.startDate).format('YYYY-MM-DD'),
        searchParam.searchFromSi,
        searchParam.searchTerm,
        Moment(searchParam.endDate).format('YYYY-MM-DD'),
        searchParam.searchToSi)
        .then(res => {
          // console.log(res);
          if (res.data.data !== undefined) {
            setTableList(res.data.data.list);
            setTotal(res.data.data.total);
          }
        });
  };

  const getExportData = () => {
    // excel pdf를 위함.
    return getPerfBKList(currentPage, listPageSize,
        Moment(searchParam.startDate).format('YYYY-MM-DD'),
        searchParam.searchFromSi,
        searchParam.searchTerm,
        Moment(searchParam.endDate).format('YYYY-MM-DD'),
        searchParam.searchToSi);
  };

  useEffect(() => {
    setIsSearch(false);
  }, []);

  useEffect(() => {
    updateList();
  }, [isSearch, currentPage, listPageSize]);

  return (
      <Frame
          propIsActiveHeader={true}
          propIsActiveSidebar={true}
      >
        <Container fluid>
          <Row className={"p-3"}>
            <Col md={12} className={"search-container py-2"}>
              <StatisticsDateSearchBox
                  searchParam={searchParam}
                  setSearchParam={setSearchParam}
                  updateList={updateList}
                  setCurrentPage={setCurrentPage}
              />
            </Col>
            <Col md={12} className={"table-container mt-3 py-2 mw-100"}>
              <TableBKS
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  listPageSize={listPageSize}
                  setListPageSize={setListPageSize}
                  total={total}
                  tableList={tableList}
                  setIsSearch={setIsSearch}
                  getFullData={getExportData}
                  updateList={updateList}
                  setTableList={setTableList}
                  setTotal={setTotal}
                  searchParam={searchParam}
              />
            </Col>
          </Row>
        </Container>
      </Frame>
  );
};

export default PerfBrokerServer;
